import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { LinkButtonLayout } from './styles';

const LinkButton = ({ icon, label, href, disabled }) => {
  const { t: translate } = useTranslation();

  return (
    <LinkButtonLayout
      href={disabled ? undefined : href}
      target="_blank"
      rel="noopener noreferrer"
      data-disabled={disabled}
      aria-disabled={disabled}
      tabIndex={disabled ? -1 : 0}
      onClick={disabled ? (e) => e.preventDefault() : undefined}
    >
      <i className={`bx ${icon}`} />
      <span>{translate(label)}</span>
    </LinkButtonLayout>
  );
};

LinkButton.propTypes = {
  icon: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  href: PropTypes.string,
  disabled: PropTypes.bool,
};

export default LinkButton;
